import { last } from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../context/AppContext'
import { airports, calculateDistance } from '../data/airports'

const StreetViewBG = ({pressFunction}) => {
  const API = 'AIzaSyBZwGVxjJ7T6EQeL4kTCwjYy6u6ZufeXMY'
  let geoLatLng = '63.82343800,20.27157200' //Storgatan
  const {geoAddress,tripDetails,setClosestAirports} = useContext(AppContext)
  let mapOptions = '&heading=210&pitch=10&fov=35'

  let fetchMap = "https://maps.googleapis.com/maps/api/geocode/json?address=" + geoAddress + "&key=" + API

  //let mapUrl = 'https://www.google.com/maps/embed/v1/streetview?key=' + API + '&location=' + geoLatLng + mapOptions
  let mapUrl
  
  const [location, setLocation] = useState(mapUrl)

  useEffect(() => {
    if (!geoAddress) return

    fetch(fetchMap)
    .then(response => response.json())
    .then(data => {
      console.log(data)
      if (!data.results[0]) return
      const latLng = data.results[0].geometry.location
      const { lat, lng } = latLng
      geoLatLng = lat + "," + lng
      console.log(geoLatLng)
      mapUrl = 'https://www.google.com/maps/embed/v1/streetview?key=' + API + '&location=' + geoLatLng + mapOptions

      const airportDistances = airports
        .map(airport => ({...airport, distance: calculateDistance(airport.latLng, latLng)}))
        .map(airport => ({...airport, distanceString: `${airport.distance < 10 ? airport.distance.toFixed(1) : airport.distance.toFixed(0)}km`}))
        .sort((a,b) => a.distance - b.distance)

      console.log(airportDistances)
      if (geoAddress === tripDetails.location) {
        setClosestAirports(prev => {
          console.log('updating from airports')
          return {...prev, from: airportDistances}
        })
      } else {
        setClosestAirports(prev => {
          console.log('updating to airports')
          return {...prev, to: airportDistances}
        })
      }


      setLocation(mapUrl)
    })
  }, [geoAddress])

  return (
      <div ID="google-map-background"  className="google-map-background content">
          {/* <button>HIDE MOBILE VIEW</button> */}
          <iframe onMouseDown={pressFunction} class="streetview"src={location} frameborder="0" style={{border:0}} allowfullscreen="" aria-hidden="false" tabindex="0" ></iframe>
            <div className="my-location-wrap">
            </div>
        </div>
  )
}

export default StreetViewBG